import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Barcode from "react-barcode";

export default function GenerateBarcode() {
  const [barcodeValue, setBarcodeValue] = useState("");
  const [designNumbers, setDesignNumbers] = useState([]);
  const barcodeRef = useRef(); // Ref for the barcode div

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  // Available brands and their corresponding design numbers
  const brandData = {
    "Nike": [101, 102, 103, 104, 105], 
    "Adidas": [201, 202, 203, 204, 205],
    "Puma": [301, 302, 303, 304, 305],
    "Reebok": [401, 402, 403, 404, 405],
    "Under Armour": [501, 502, 503, 504, 505],
  };

  // Handle brand change to update the design numbers
  const handleBrandChange = (e) => {
    const selectedBrand = e.target.value;
    setDesignNumbers(brandData[selectedBrand] || []);
    setValue("designNumber", ""); // Reset design number
  };

  const onSubmit = (data) => {
    const generatedBarcode = `${data.brandName}-${data.designNumber}-${data.size}`;
    setBarcodeValue(generatedBarcode);
    Swal.fire("Success!", `Barcode for ${data.brandName} generated.`, "success");
  };

  // Print Barcode
  const handlePrint = () => {
    if (barcodeValue) {
      const printContent = barcodeRef.current.innerHTML;
      const originalContent = document.body.innerHTML;

      document.body.innerHTML = printContent;
      window.print();
      document.body.innerHTML = originalContent;

      // Re-render the page after printing
      window.location.reload();
    }
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Generate Barcode</h4>
                <div className="d-flex">
                  {barcodeValue && (
                    <button
                      onClick={handlePrint}
                      className="btn btn-link p-0 me-4"
                      title="Print"
                      style={{ position: "relative" }}
                    >
                      <img
                        src="/assets/images/kidskart/icon/printer.png"
                        alt="Print Icon"
                        className="print-icon"
                      />
                    </button>
                  )}
                  <Link to="/products">
                    <img
                      src="/assets/images/kidskart/icon/back-button.png"
                      alt="Back"
                    />
                  </Link>
                </div>
              </div>

              <div className="card-body py-3">
                <div className="row">
                  {/* Form Section */}
                  <div className="col-md-6">
                    <div className="basic-form">
                      <form onSubmit={handleSubmit(onSubmit)}>
                        {/* Brand Name Dropdown */}
                        <div className="mb-4">
                          <label className="form-label">Brand Name</label>
                          <select
                            className="form-control"
                            {...register("brandName", {
                              required: "Brand Name is required",
                            })}
                            onChange={handleBrandChange}
                          >
                            <option value="">Select Brand</option>
                            {Object.keys(brandData).map((brand) => (
                              <option key={brand} value={brand}>
                                {brand}
                              </option>
                            ))}
                          </select>
                          {errors.brandName && (
                            <p className="error">{errors.brandName.message}</p>
                          )}
                        </div>

                        {/* Design Number Dropdown */}
                        <div className="mb-4">
                          <label className="form-label">Design Number</label>
                          <select
                            className="form-control"
                            {...register("designNumber", {
                              required: "Design Number is required",
                            })}
                          >
                            <option value="">Select Design Number</option>
                            {designNumbers.map((design) => (
                              <option key={design} value={design}>
                                {design}
                              </option>
                            ))}
                          </select>
                          {errors.designNumber && (
                            <p className="error">{errors.designNumber.message}</p>
                          )}
                        </div>

                        {/* Size */}
                        <div className="mb-4">
                          <label className="form-label">Size</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Size"
                            {...register("size", {
                              required: "Size is required",
                            })}
                          />
                          {errors.size && <p className="error">{errors.size.message}</p>}
                        </div>

                        {/* Submit Button */}
                        <div>
                          <button type="submit" className="btn btn-primary w-100">
                            GENERATE BARCODE
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>

                  {/* Barcode Display Section */}
                  <div className="col-md-6 d-flex flex-column align-items-center justify-content-center">
                    {barcodeValue ? (
                      <div className="text-center my-4">
                        <h5>Generated Barcode:</h5>
                        <div ref={barcodeRef}>
                          <Barcode value={barcodeValue} />
                        </div>
                      </div>
                    ) : (
                      <p className="text-muted">No barcode generated yet.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
